module.exports = __webpack_public_path__ + "img/ArmadilloChecklist_4.50c4ad23.gif";